/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Officialcompanynamecompanyregister4Inputs */

const en_officialcompanynamecompanyregister4 = /** @type {(inputs: Officialcompanynamecompanyregister4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official Company Name (Company Register)`)
};

const de_officialcompanynamecompanyregister4 = /** @type {(inputs: Officialcompanynamecompanyregister4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offizieller Firmenname (Handelsregister)`)
};

/**
* | output |
* | --- |
* | "Official Company Name (Company Register)" |
*
* @param {Officialcompanynamecompanyregister4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const officialcompanynamecompanyregister4 = /** @type {((inputs?: Officialcompanynamecompanyregister4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Officialcompanynamecompanyregister4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_officialcompanynamecompanyregister4(inputs)
	return de_officialcompanynamecompanyregister4(inputs)
});
export { officialcompanynamecompanyregister4 as "officialCompanyNameCompanyRegister" }